import { BLUE } from '../constants/colors';

export default function StatCard({label, value, sub, color=BLUE, bg="#F8FAFC", border="#EEF2F7", large=false}){
  return(
    <div style={{background:bg,borderRadius:14,padding:large?"20px 22px":"16px 18px",border:`1px solid ${border}`,textAlign:"center",display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
      <div style={{fontSize:11,color:"#94a3b8",fontFamily:"sans-serif",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em"}}>{label}</div>
      {(function(){
        const str = String(value);
        // Shrink font as string gets longer: ≤6 chars=full, 7-8=medium, 9-10=small, 11+=xs
        const fs = large
          ? (str.length<=7?34:str.length<=9?27:str.length<=11?22:18)
          : (str.length<=7?22:str.length<=9?18:14);
        return <div style={{fontSize:fs,fontWeight:900,color,fontFamily:"sans-serif",letterSpacing:"-0.02em",lineHeight:1.1,wordBreak:"break-all"}}>{value}</div>;
      })()}
      {sub&&<div style={{fontSize:11,color:"#94a3b8",fontFamily:"sans-serif",lineHeight:1.4,textAlign:"center"}}>{sub}</div>}
    </div>
  );
}

// Section wrapper — clean card with consistent spacing